var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1H17C18.1046 1 19 1.8954 19 3V17C19 18.1046 18.1046 19 17 19H3C1.8954 19 1 18.1046 1 17V3C1 1.8954 1.8954 1 3 1ZM0 3C0 1.3431 1.3431 0 3 0H17C18.6569 0 20 1.3431 20 3V17C20 18.6569 18.6569 20 17 20H3C1.3431 20 0 18.6569 0 17V3ZM8.9417 12.9425L15.4415 6.4419L14.5576 5.5581L8.4997 11.6166L5.4416 8.5581L4.5576 9.4419L8.0578 12.9425C8.175 13.0597 8.334 13.1255 8.4997 13.1255C8.6655 13.1255 8.8245 13.0597 8.9417 12.9425Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon);
export default __webpack_public_path__ + "static/media/checkbox-icon.ed9afe9fdfacc9ef45df6a42e59438b1.svg";
export { ForwardRef as ReactComponent };